export const getForm = (state) => state

export const getOperator = (state) => getForm(state).operator

export const getAgreement = (state) => getForm(state).agreement

export const getPorts = (state) => getForm(state).ports
